import axios from 'axios';
import { ApiResponse } from 'types';

export interface WidgetsSdkInitPayloadRequest {
  utilityAccountIdentifier: string;
  fuelType: string;
  accountType: string;
  // allow extra fields if needed later
  [key: string]: any;
}

export interface WidgetsSdkInitPayloadResponse {
  encryptedPayload: string;
}

export const CxWebEncryptionApis = {
  /**
   * Get Widgets SDK encrypted init payload via Tool API (proxypulse).
   *
   * Proxypulse endpoint:
   * POST /v1/cx/widgets-sdk/init-payload
   * Body: { projectId, clientId, payload }  // payload excludes accessToken; backend injects it
   * Response: { encryptedPayload }
   */
  getWidgetsSdkInitPayload: async (
    projectId: string,
    clientId: string,
    payload: WidgetsSdkInitPayloadRequest
  ): Promise<ApiResponse<WidgetsSdkInitPayloadResponse>> => {
    const toolApiUrl = process.env.REACT_APP_TOOL_API_URL;
    if (!toolApiUrl) {
      return {
        error: {
          code: 'MISSING_TOOL_API_URL',
          message: 'REACT_APP_TOOL_API_URL is not set',
        },
      };
    }

    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return {
        error: {
          code: 'MISSING_AUTH_TOKEN',
          message: 'Missing access token in localStorage',
        },
      };
    }

    try {
      const resp = await axios.post<WidgetsSdkInitPayloadResponse>(
        `${toolApiUrl}/v1/cx/widgets-sdk/init-payload`,
        { projectId, clientId, payload },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!resp.data?.encryptedPayload) {
        return {
          error: {
            code: 'INVALID_RESPONSE',
            message: 'Missing encryptedPayload in response',
          },
        };
      }

      return { data: resp.data };
    } catch (error: any) {
      return {
        error: {
          code: error.response?.data?.error?.code || 'UNKNOWN_ERROR',
          message:
            error.response?.data?.error?.message ||
            error.message ||
            'Failed to get encrypted init payload',
        },
      };
    }
  },
};


